export default "__VITE_ASSET__a663283c__"